import { DefaultState } from 'features/types';

export type SelectedContextState = DefaultState & {
  programContext: {
    selectedId?: string;
    tab: SelectedProgramContextTab;
    data: {
      programDataIsLoading: boolean;
      programData: ProgramDataForContext | null;
    },
  }
}

export type ProgramDataForContext = {
  id: string;
  name: string;
  logo?: string;
}

export enum SelectedProgramContextTab {
  GroupHub = 'Group Hub',
  GroupProductsAndServices = 'Products & Services',
  GroupEvents = 'Events',
  GroupMembers = 'Members',
  GroupAbout = 'About',
}

export enum SelectedProgramContextTabParams {
  GroupResources = 'resources',
  GroupResourcesProductsAndServices = 'products-services',
  GroupResourcesEvents = 'events',
  GroupMembers = 'job-seekers',
  GroupAbout = 'about',
}
